angular.module 'shared'
  .factory 'IntercomService', ($rootScope) ->
    track: _.debounce (event) ->
      if window.Intercom
        window.Intercom('trackEvent', event)
    , 100
